"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapIndexProfile = exports.cleanIndexWrapper = exports.cleanBuilderList = exports.cleanIdent = exports.getDeviceEndpoint = exports.getBuilderEndpoint = exports.getIdentEndpoint = exports.getSpecificUserTaskEndpoint = exports.getUserTaskEndpoint = exports.getProfilesTaskEndpoint = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const Paths_1 = require("../../Paths");
const Utils_1 = require("../../Utils");
const IndexApiProfileRequestTypes_1 = require("../Types/IndexApiProfileRequestTypes");
const IndexProfile_1 = require("../Types/IndexProfile");
const Bridges_1 = require("./helpers/Bridges");
const Channels_1 = require("./helpers/Channels");
const Loads_1 = require("./helpers/Loads");
const Mesh_1 = require("./helpers/Mesh");
const Scenes_1 = require("./helpers/Scenes");
const Schedules_1 = require("./helpers/Schedules");
const Simples_1 = require("./helpers/Simples");
const States_1 = require("./helpers/States");
const Switches_1 = require("./helpers/Switches");
const WifiDetails_1 = require("./helpers/WifiDetails");
const Groups_1 = require("./helpers/Groups");
const getProfilesTaskEndpoint = (session, profileId) => `${session.baseUrl}/profiles/${profileId}/tasks`;
exports.getProfilesTaskEndpoint = getProfilesTaskEndpoint;
const getUserTaskEndpoint = (session, isTask) => `${Paths_1.Constants.BACKEND_ENDPOINT_V2}/user${isTask ? "/tasks" : ""}`;
exports.getUserTaskEndpoint = getUserTaskEndpoint;
const getSpecificUserTaskEndpoint = (session, userSub) => `${session.baseUrl}/user/${userSub}`;
exports.getSpecificUserTaskEndpoint = getSpecificUserTaskEndpoint;
const getIdentEndpoint = () => `${Paths_1.Constants.BACKEND_ENDPOINT_V2}/user/ident`;
exports.getIdentEndpoint = getIdentEndpoint;
const getBuilderEndpoint = () => `${Paths_1.Constants.BACKEND_ENDPOINT}/v1/builders`;
exports.getBuilderEndpoint = getBuilderEndpoint;
const getDeviceEndpoint = (session, serialNumber) => `${session.baseUrl}/device/${serialNumber}`;
exports.getDeviceEndpoint = getDeviceEndpoint;
function cleanThings(things) {
    const cleanedThings = {};
    for (const rawThingKey of Object.keys(things)) {
        const rawThing = things[rawThingKey];
        cleanedThings[rawThingKey] = Object.assign(Object.assign({}, rawThing), { connected: !!rawThing.connected, lastCheckin: {
                firmwareRevision: rawThing.lastCheckin && rawThing.lastCheckin.firmwareRevision
                    && rawThing.lastCheckin.firmwareRevision !== "0.0.1" ? rawThing.lastCheckin.firmwareRevision : IndexProfile_1.UNKNOWN,
                ssid: rawThing.lastCheckin ? rawThing.lastCheckin.ssid : IndexProfile_1.UNKNOWN,
                time: Date.parse(String(rawThing.lastCheckin && rawThing.lastCheckin.time)) || 0,
            }, model: Object.assign(Object.assign({}, rawThing.model), { firmwareRevision: rawThing.model.firmwareRevision || IndexProfile_1.UNKNOWN, hardwareRevision: rawThing.model.hardwareRevision || IndexProfile_1.UNKNOWN }) });
    }
    return cleanedThings;
}
function cleanIdent(ident) {
    const tmpCleanIdent = Object.assign(Object.assign({}, ident), { tos: {
            signedAt: new Date(0),
            signedVersion: "0",
        } });
    try {
        const cleanTos = {
            signedAt: new Date(ident.tos.signedAt),
            signedVersion: ident.tos.signedVersion,
        };
        tmpCleanIdent.tos = cleanTos;
    }
    catch (_a) {
        Utils_1.Log.error("Failed to find a proper tos for this user, falling back to epoch");
    }
    return tmpCleanIdent;
}
exports.cleanIdent = cleanIdent;
function cleanBuilderList(builderList) {
    const cleanedBuilderList = [];
    for (const key in builderList) {
        cleanedBuilderList.push({
            builderId: key,
            name: builderList[key].name,
        });
    }
    return cleanedBuilderList;
}
exports.cleanBuilderList = cleanBuilderList;
function cleanIndexWrapper(rawIndex) {
    const cleanedWrapper = {
        ident: cleanIdent(rawIndex.ident),
        profiles: {},
    };
    const profileKeys = Object.keys(rawIndex.profiles);
    for (const uuid of profileKeys) {
        const profile = rawIndex.profiles[uuid];
        const cleanedThings = cleanThings(profile.things);
        cleanedWrapper.profiles[uuid] = Object.assign(Object.assign({}, profile), { things: cleanedThings });
    }
    return cleanedWrapper;
}
exports.cleanIndexWrapper = cleanIndexWrapper;
function isActuatorLoad(actuator) {
    return actuator.deviceType === IndexApiProfileRequestTypes_1.IndexAPIDeviceType.LOAD || actuator.deviceType === IndexApiProfileRequestTypes_1.IndexAPIDeviceType.PLUG;
}
function isDeviceLoad(device) {
    return device.type === IndexApiProfileRequestTypes_1.IndexAPIDeviceType.LOAD || device.type === IndexApiProfileRequestTypes_1.IndexAPIDeviceType.PLUG;
}
function getTimezoneData(tz) {
    const momentTz = (0, moment_timezone_1.default)().tz(tz);
    return {
        name: tz,
        utcOffsetM: momentTz.utcOffset(),
    };
}
function wrapIndexProfile(cleanedProfile, currentProfileUUID) {
    var _a;
    const profile = cleanedProfile.profiles[`${Paths_1.UuidPrefixes.profileId}${currentProfileUUID}`];
    const memberships = Object.values(profile.memberships);
    const actuators = Object.values(profile.actuators);
    const devices = Object.values(profile.devices);
    const things = Object.values(profile.things);
    const simples = Object.values(profile.simples);
    const users = Object.values(profile.users);
    const currentUserUUID = ((_a = users.find((u) => u.email === cleanedProfile.ident.email)) === null || _a === void 0 ? void 0 : _a.id) || "USER_ID_NOT_FOUND";
    const loadActuators = actuators.filter((a) => isActuatorLoad(a));
    const loadDevices = devices.filter((d) => isDeviceLoad(d));
    const switchDevices = devices.filter((d) => d.type === IndexApiProfileRequestTypes_1.IndexAPIDeviceType.SWITCH || d.type === IndexApiProfileRequestTypes_1.IndexAPIDeviceType.PLUG).map((d) => {
        switch (d.type) {
            case IndexApiProfileRequestTypes_1.IndexAPIDeviceType.PLUG:
                return Object.assign(Object.assign({}, d), { id: `${Switches_1.PLUG_SWITCH_ID_MODIFIER}${d.id}` });
            default:
                return d;
        }
    });
    const loadsWithoutScenes = (0, Loads_1.mapActuatorsAndDevices)(loadActuators, loadDevices, things);
    const groupActuators = actuators.filter((a) => a.deviceType === IndexApiProfileRequestTypes_1.IndexAPIDeviceType.ZONE);
    const groupDevices = devices.filter((d) => d.type === IndexApiProfileRequestTypes_1.IndexAPIDeviceType.ZONE);
    const sceneActuators = actuators.filter((a) => a.deviceType === IndexApiProfileRequestTypes_1.IndexAPIDeviceType.SCENE);
    const sceneDevices = devices.filter((d) => d.type === IndexApiProfileRequestTypes_1.IndexAPIDeviceType.SCENE);
    const scenes = (0, Scenes_1.mapScenes)(sceneActuators, sceneDevices, loadDevices, switchDevices, devices);
    const { schedules, warrantyActive } = profile;
    const bridgeDevices = devices.filter((d) => d.type === IndexApiProfileRequestTypes_1.IndexAPIDeviceType.BRIDGE);
    return {
        mesh: (0, Mesh_1.getMeshInfo)(profile),
        uuid: currentProfileUUID,
        timezone: getTimezoneData(profile.timeZone),
        wifi: (0, WifiDetails_1.getWifiEnabledDeviceDetails)(profile),
        name: profile.name,
        loads: (0, Scenes_1.addSceneLocationsToLoads)(loadsWithoutScenes, switchDevices),
        switches: (0, Switches_1.mapSwitches)(switchDevices, things),
        builder: profile.builder,
        bridges: (0, Bridges_1.mapBridgeDevicesAndThings)(bridgeDevices, things),
        groups: (0, Groups_1.mapGroups)(groupActuators, groupDevices),
        scenes,
        schedules: (0, Schedules_1.mapSchedules)(schedules, profile.actuators, profile.devices),
        seedStates: (0, States_1.extractStates)(actuators),
        simples: (0, Simples_1.mapSimpleDevices)(simples),
        memberships,
        users: profile.users,
        currentUser: {
            auth0Sub: cleanedProfile.ident.sub,
            uuid: currentUserUUID,
        },
        channel: (0, Channels_1.parseChannel)(profile.channel),
        location: profile.location,
        fetchTime: Date.now(),
        warrantyActive,
        createdAt: profile.createdAt,
    };
}
exports.wrapIndexProfile = wrapIndexProfile;
//# sourceMappingURL=index.js.map